import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../../authConfig";

function AuthCallback() {
  // MSAL hook
  const { instance } = useMsal();

  useEffect(() => {
    const handleAuth = async () => {
      try {
        // Check if tokens already exist (processed by initialization)
        const accessToken = localStorage.getItem("accessToken");
        if (accessToken) {
          // Already processed, redirect immediately
          window.location.replace("/dashboards/my-dashboard");
          return;
        }

        // Handle redirect response from MSAL - wait for completion
        // Note: This may return null if already processed during initialization
        const response = await instance.handleRedirectPromise();
        
        if (response) {
          console.log("MSAL redirect response:", response);
          
          // Store tokens
          if (response.accessToken) {
            localStorage.setItem("accessToken", response.accessToken);
          }
          
          // Store user info
          if (response.account) {
            localStorage.setItem("userInfo", JSON.stringify({
              name: response.account.name,
              email: response.account.username,
            }));
          }

          // Redirect immediately using window.location.replace
          window.location.replace("/dashboards/my-dashboard");
          return;
        }

        // Check if user is already authenticated
        const currentAccounts = instance.getAllAccounts();
        if (currentAccounts.length > 0) {
          const account = currentAccounts[0];
          
          // Try to acquire token silently
          try {
            const tokenResponse = await instance.acquireTokenSilent({
              ...loginRequest,
              account: account,
            });

            if (tokenResponse.accessToken) {
              localStorage.setItem("accessToken", tokenResponse.accessToken);
            }
            
            localStorage.setItem("userInfo", JSON.stringify({
              name: account.name,
              email: account.username,
            }));

            // Redirect immediately after token acquisition completes
            window.location.replace("/dashboards/my-dashboard");
            return;
          } catch (silentError) {
            console.error("Silent token acquisition failed:", silentError);
            // If silent acquisition fails, redirect to login
            localStorage.clear();
            sessionStorage.clear();
            window.location.replace("/authentication/sign-in/basic");
            return;
          }
        }

        // No accounts found - redirect to sign-in
        window.location.replace("/authentication/sign-in/basic");

      } catch (e) {
        console.error("Auth callback error:", e);
        window.location.replace("/authentication/sign-in/basic");
      }
    };

    handleAuth();
  }, [instance]);

  // Don't render anything - just process and redirect
  return null;
}

export default AuthCallback;
